import { Box, Skeleton } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import Table, { TableProps } from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { TableCellProps } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { ReactNode } from 'react';
import { EmptyText } from 'src/utils/constants/config';

const StyledTable = styled(Table)(({ theme }) => ({
  marginTop: theme.spacing(3),
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: theme.spacing(1),
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  borderBottom: '1px solid #D9D9F9',
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.background.paper1,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

interface IPropsDataTable extends TableProps {
  listData: Array<{
    key: string;
    title: string;
    value: React.ReactNode | string;
    renderSubText?: () => ReactNode;
  } | null>;
  loading?: boolean;
  sxTableCellTitle?: TableCellProps['sx'];
  sxTableCellValue?: TableCellProps['sx'];
}

export default function DataTable({
  listData,
  sxTableCellTitle = {},
  sxTableCellValue = {},
  loading = false,
  ...props
}: IPropsDataTable) {
  const theme = useTheme();

  const loadingSkeleton = new Array(5).fill(0).map((_, index) => {
    return (
      <StyledTableRow key={index}>
        <StyledTableCell component="th">
          <Skeleton />
        </StyledTableCell>
        <StyledTableCell>
          <Skeleton />
        </StyledTableCell>
      </StyledTableRow>
    );
  });

  if (loading) {
    return (
      <StyledTable>
        <TableBody>{loadingSkeleton}</TableBody>
      </StyledTable>
    );
  }
  return (
    <StyledTable aria-label="customized table" {...props}>
      <TableBody>
        {listData
          .filter((data) => data !== null)
          .map((data, index) => (
            <StyledTableRow key={(data?.key || '') + index}>
              <StyledTableCell component="th" sx={{ ...sxTableCellTitle }}>
                <Box sx={{ ...theme.typography.subtitle2 }}>{data?.title || EmptyText}</Box>
              </StyledTableCell>
              <StyledTableCell sx={{ ...sxTableCellValue }}>
                <Box sx={{ ...theme.typography.body2, color: theme.palette.text.secondary }}>
                  {data?.value || EmptyText}
                </Box>
                {data?.renderSubText && data.renderSubText()}
              </StyledTableCell>
            </StyledTableRow>
          ))}
      </TableBody>
    </StyledTable>
  );
}
